import React, { SFC } from "react";
import "./style.scss";

type PropsType = {
    inline?: boolean;
    horizontal?: "small" | "medium" | "large" | "xlarge";
    vertical?: "small" | "medium" | "large" | "xlarge";
};

const Spacer = (props: PropsType): SFC => {
    const verticalClass = props.vertical ? ` Spacer--vertical-${props.vertical}` : "";
    const horizontalClass = props.horizontal ? ` Spacer--horizontal-${props.horizontal}` : "";
    const inlineClass = props.inline ? ` Spacer--inline` : "";
    const className = `Spacer${inlineClass}${horizontalClass}${verticalClass}`;

    return <div className={className}>{props.children}</div>;
};

export default Spacer;
export { PropsType };
